import axios from 'axios';

import { apiUrl, config } from '../Shared/config';


export const updateColumns = async (columns, scenarioId, type) => {

  if (type === "reporting") {
    // console.log("9 - updateReportingColumns=", columns, scenarioId);
    try {
      const { data } = await axios.put(apiUrl + 'columns/reporting', { columns, scenarioId }, config);

      return data.success ? data : data?.error;

    } catch (error) { console.log("15 - error=", error); return error.response?.data?.error || 'error'; }
  }
};


export const getColumns = async (scenarioId, devicesType) => {

  // console.log("22 - getColumns=", scenarioId, devicesType);
    try {
    const { data } = await axios.get(apiUrl + 'columns/reporting' + (scenarioId !== undefined ? `/scenario=${scenarioId}` : ``) + (devicesType !== undefined ? `&devicesType=${devicesType}` : ``), config);

      return data.success ? data : data?.error;

    } catch (error) { return error.response?.data?.error || 'error'; }

};


export const updateColumnsForModule = async (columns, module, type) => {

  if (type === "reporting") {
    // console.log("36 - updateReportingColumnsForModule=", columns, module);
    try {
      const { data } = await axios.put(apiUrl + 'columns/reportingForModule', { columns, module }, config);

      return data.success ? data : data?.error;

    } catch (error) { console.log("42 - error=", error); return error.response?.data?.error || 'error'; }
  }
};


export const getColumnsForModule = async (module) => {

  // console.log("49 - getColumnsForModule=", module);
  try {
    const { data } = await axios.get(apiUrl + 'columns/reportingForModule' + (module !== undefined ? `/module=${module}` : ``), config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }

};



export const updateSortModel = async (model, scenarioId, type) => {

  if (type === "reporting") {
    // console.log("9 - updateReportingColumns=", columns, scenarioId);
    try {
      const { data } = await axios.put(apiUrl + 'columns/sortModel', { model, scenarioId }, config);

      return data.success ? data : data?.error;

    } catch (error) { console.log("15 - error=", error); return error.response?.data?.error || 'error'; }
  }
};


export const getSortModel = async (scenarioId, devicesType) => {

  // console.log("77 - getSortModel=", scenarioId, devicesType);
  try {
    const { data } = await axios.get(apiUrl + 'columns/sortModel' + (scenarioId !== undefined ? `/scenario=${scenarioId}` : ``) + (devicesType !== undefined ? `&devicesType=${devicesType}` : ``), config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }

};


export const updateSortModelForModule = async (model, module, type) => {

  if (type === "reporting") {
    // console.log("36 - updateReportingColumnsForModule=", columns, module);
    try {
      const { data } = await axios.put(apiUrl + 'columns/sortModelForModule', { model, module }, config);

      return data.success ? data : data?.error;

    } catch (error) { console.log("42 - error=", error); return error.response?.data?.error || 'error'; }
  }
};


export const getSortModelForModule = async (module) => {

  // console.log("49 - getSortModelForModule=", module);
  try {
    const { data } = await axios.get(apiUrl + 'columns/sortModelForModule' + (module !== undefined ? `/module=${module}` : ``), config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }

};


export const getDiskHealthPercentageComputingRules = async (groupId) => {
  try {
    const { data } = await axios.get(apiUrl + 'columns/diskHealthPercentageComputingRules' + (groupId !== undefined ? `/group=${groupId}` : ``), config);
    return data.success ? data : data?.error;

  } catch (error) {
    console.log("124 - error=", error);
    return error.response?.data?.error || 'error';
  }
};


export const setDiskHealthPercentageComputingRules = async (groupId, rules) => {
  try {
    // const { data } = await axios.get(apiUrl + 'columns/diskHealthPercentageComputingRules' + (groupId !== undefined ? `/group=${groupId}` : ``), config);
    const { data } = await axios.put(apiUrl + 'columns/diskHealthPercentageComputingRules', { groupId, rules }, config);

    return data.success ? data : data?.error;

  } catch (error) {
    console.log("124 - error=", error);
    return error.response?.data?.error || 'error';
  }
};
